module.exports = __webpack_public_path__ + "static/media/default_upload_image.36c845ae.png";